import { Component } from '@angular/core';

/**
 * Veri sorumlusu kimlik bloğu. Üç yasal metinde de aynen görünür.
 * Adres / e-posta / KEP değişikliğinde yalnızca bu dosya güncellenir.
 */
@Component({
  selector: 'app-veri-sorumlusu',
  templateUrl: './veri-sorumlusu.component.html'
})
export class VeriSorumlusuComponent {}
